import React, { Component } from 'react';
import { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
import { Loader } from 'react-loaders';
import FileUploadService from '~/services/FileUploadService';
import { Container } from './styles';
import ReactPlayer from "react-player";

class VideoFromService extends Component {
  state = {
    loading: true,
    video: null,
  };

  componentDidMount() {
    const { video } = this.state;
    if (!video) this.loadVideo();
  }

  toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

  loadVideo = async () => {
    const { videoUuid } = this.props;
    const file = await FileUploadService.getFile(videoUuid);
    const video = await this.toBase64(file);
    this.setState({ video, loading: false });
  };

  render() {
    const {
      style,
      theme,
      width,
      height,
    } = this.props;
    const { loading, video } = this.state;
    return (
      <Container style={style} width={width} height={height} >
        {loading ? (
          <Loader active type="line-spin-fade-loader" color={theme.colors.primary} />
        ) : (
          <ReactPlayer
            width='100%'
            height='100%'
            url={video}
            alt="video"
            className="react-player"
            controls={true} />
        )}
      </Container>
    );
  }
}

VideoFromService.defaultProps = {
  style: null,
  stylevideo: null,
};

VideoFromService.propTypes = {
  videoUuid: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  style: PropTypes.shape(),
  stylevideo: PropTypes.shape(),
  fill: PropTypes.string,
  theme: PropTypes.shape().isRequired,
};

export default withTheme(VideoFromService);
